import { Component, EventEmitter, OnInit, Output } from '@angular/core';
//
import { EmployeeView } from '../../../../shared/sdk';

@Component({
  selector: 'app-schedule-list',
  templateUrl: './schedule-list.component.html',
  styleUrls: ['./schedule-list.component.scss'],
})
export class ScheduleListComponent implements OnInit {
  @Output() mySelected: EventEmitter<EmployeeView[]> = new EventEmitter<EmployeeView[]>();

  constructor() {}

  ngOnInit() {}

  grid_onSelected(items: EmployeeView[]) {
    this.mySelected.emit(items);
  }
}
